export default __webpack_public_path__ + "static/media/alert2.e5477e98.mp3";